import { DateTime } from 'luxon'

export const gasConsumptionItemKey = 'yyyyMMddHHmm'

type Item = { [yyyyMMddHHmm: string]: number }

export type GasConsumptionData = {
  currentGasConsumption: number
  co2Emission: number
  items: Item
}

export default class Consumption {
  declare currentGasConsumption: number
  declare co2Emission: number
  declare items: Item

  constructor(params: GasConsumptionData) {
    Object.assign(this, params)
  }

  getItem(date: DateTime): number | null {
    return this.items[date.toFormat(gasConsumptionItemKey)] ?? null
  }
}
